import { useMemo } from "react";
import dayjs, { Dayjs } from "dayjs";
import { useNewTeacherIds } from "../TeacherCoordinatorReview/useNewTeacherIds.ts";
import { useTeacherCreatedAt } from "./useTeacherCreatedAt.ts";

export const NEW_TEACHER_BOOST_WEEKS = 3;
export const NEW_TEACHER_BOOST_MAX_CLASSES = 20;

export type NewTeacherBoost =
  | { isActive: false }
  | { isActive: true; until: Dayjs };

export function useNewTeacherBoost(teacherId: string): NewTeacherBoost {
  const createdAt = useTeacherCreatedAt(teacherId);
  const checks = useMemo(
    () => (createdAt ? [{ teacherId, createdAt }] : []),
    [teacherId, createdAt],
  );
  const { newTeacherIds } = useNewTeacherIds(checks);

  if (!createdAt || !newTeacherIds.has(teacherId)) return { isActive: false };
  return {
    isActive: true,
    until: dayjs(createdAt).add(NEW_TEACHER_BOOST_WEEKS, "week"),
  };
}
